import {Component, inject} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {RouterLink, RouterOutlet} from "@angular/router";
import {watchParentParam} from "@utils";
import {ArtworkService} from "@api-services";
import {rxResource} from "@angular/core/rxjs-interop";

@Component({
  selector: 'wun-artworks',
  imports: [
    TranslocoDirective,
    RouterOutlet,
    RouterLink
  ],
  templateUrl: './artworks.component.html',
  styleUrl: './artworks.component.scss'
})
export class ArtworksComponent {

  artist = watchParentParam("id", 2);

  artworkService = inject(ArtworkService)
  artworks = rxResource({
    params: this.artist,
    stream: params => this.artworkService.artworksFindAndPaginate({
      filters: JSON.stringify({artist: params.params}),
      includes: JSON.stringify(['mainAttachment', 'attachments']),
      pageSize: 1000
    })
  })
}
